import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    backgroundColor: '#F6F6F6',
    padding: '1rem',
  },
  paragraph: {
    marginBottom: '1rem',
    fontSize: '1.2rem',
    color: 'black',
    fontWeight: 'bold',
  },
  openCookieCTA: {
    '& div': {
      padding: '1rem 2.0625rem 0.75rem',
    },
  },
}));
